// Module
var code = "<div class=\"ali-danmuku-control\">\n  <div class=\"ali-danmu-input-wrap\"></div>\n  <i class=\"iconfont icon-danmu-close\"></i>\n  <div class=\"player-tooltip close\"></div>\n  <i class=\"iconfont icon-danmu-open\" style=\"display: none;\"></i>\n  <div class=\"player-tooltip open\"></div>  \n</div>";
// Exports
module.exports = code;